import { Link, theme } from '@fe-toolkit/web-components/ssr'
import React from 'react'
import styled from 'styled-components'

export const FixedIconLink = styled(Link)<{ href: string; children: React.ReactNode }>`
  position: absolute;
  display: block;
  right: -3px;
  top: 0;
  padding: 3px;
  line-height: 1;
  ${theme.breakpoints.up('medium')} {
    top: calc(50% - 14px);
  }
`
